//THIS FILE IS AUTO GENERATED
//DO NOT EDIT AND DELETE IT

    

      import ConfirmarSAUrl from "ASSETS_DIR/locales/ar-SA/Confirm.json";

      import ConsentarSAUrl from "ASSETS_DIR/locales/ar-SA/Consent.json";

      import ErrorsarSAUrl from "ASSETS_DIR/locales/ar-SA/Errors.json";

      import LoginarSAUrl from "ASSETS_DIR/locales/ar-SA/Login.json";

      import TenantListarSAUrl from "ASSETS_DIR/locales/ar-SA/TenantList.json";

      import WizardarSAUrl from "ASSETS_DIR/locales/ar-SA/Wizard.json";

      import ConfirmazUrl from "ASSETS_DIR/locales/az/Confirm.json";

      import ConsentazUrl from "ASSETS_DIR/locales/az/Consent.json";

      import ErrorsazUrl from "ASSETS_DIR/locales/az/Errors.json";

      import LoginazUrl from "ASSETS_DIR/locales/az/Login.json";

      import TenantListazUrl from "ASSETS_DIR/locales/az/TenantList.json";

      import WizardazUrl from "ASSETS_DIR/locales/az/Wizard.json";

      import ConfirmbgUrl from "ASSETS_DIR/locales/bg/Confirm.json";

      import ConsentbgUrl from "ASSETS_DIR/locales/bg/Consent.json";

      import ErrorsbgUrl from "ASSETS_DIR/locales/bg/Errors.json";

      import LoginbgUrl from "ASSETS_DIR/locales/bg/Login.json";

      import TenantListbgUrl from "ASSETS_DIR/locales/bg/TenantList.json";

      import WizardbgUrl from "ASSETS_DIR/locales/bg/Wizard.json";

      import ConfirmcsUrl from "ASSETS_DIR/locales/cs/Confirm.json";

      import ConsentcsUrl from "ASSETS_DIR/locales/cs/Consent.json";

      import ErrorscsUrl from "ASSETS_DIR/locales/cs/Errors.json";

      import LogincsUrl from "ASSETS_DIR/locales/cs/Login.json";

      import TenantListcsUrl from "ASSETS_DIR/locales/cs/TenantList.json";

      import WizardcsUrl from "ASSETS_DIR/locales/cs/Wizard.json";

      import ConfirmdeUrl from "ASSETS_DIR/locales/de/Confirm.json";

      import ConsentdeUrl from "ASSETS_DIR/locales/de/Consent.json";

      import ErrorsdeUrl from "ASSETS_DIR/locales/de/Errors.json";

      import LogindeUrl from "ASSETS_DIR/locales/de/Login.json";

      import TenantListdeUrl from "ASSETS_DIR/locales/de/TenantList.json";

      import WizarddeUrl from "ASSETS_DIR/locales/de/Wizard.json";

      import ConfirmelGRUrl from "ASSETS_DIR/locales/el-GR/Confirm.json";

      import ConsentelGRUrl from "ASSETS_DIR/locales/el-GR/Consent.json";

      import ErrorselGRUrl from "ASSETS_DIR/locales/el-GR/Errors.json";

      import LoginelGRUrl from "ASSETS_DIR/locales/el-GR/Login.json";

      import TenantListelGRUrl from "ASSETS_DIR/locales/el-GR/TenantList.json";

      import WizardelGRUrl from "ASSETS_DIR/locales/el-GR/Wizard.json";

      import ConfirmenUrl from "ASSETS_DIR/locales/en/Confirm.json";

      import ConsentenUrl from "ASSETS_DIR/locales/en/Consent.json";

      import ErrorsenUrl from "ASSETS_DIR/locales/en/Errors.json";

      import LoginenUrl from "ASSETS_DIR/locales/en/Login.json";

      import TenantListenUrl from "ASSETS_DIR/locales/en/TenantList.json";

      import WizardenUrl from "ASSETS_DIR/locales/en/Wizard.json";

      import ConfirmesUrl from "ASSETS_DIR/locales/es/Confirm.json";

      import ConsentesUrl from "ASSETS_DIR/locales/es/Consent.json";

      import ErrorsesUrl from "ASSETS_DIR/locales/es/Errors.json";

      import LoginesUrl from "ASSETS_DIR/locales/es/Login.json";

      import TenantListesUrl from "ASSETS_DIR/locales/es/TenantList.json";

      import WizardesUrl from "ASSETS_DIR/locales/es/Wizard.json";

      import ConfirmfiUrl from "ASSETS_DIR/locales/fi/Confirm.json";

      import ConsentfiUrl from "ASSETS_DIR/locales/fi/Consent.json";

      import ErrorsfiUrl from "ASSETS_DIR/locales/fi/Errors.json";

      import LoginfiUrl from "ASSETS_DIR/locales/fi/Login.json";

      import TenantListfiUrl from "ASSETS_DIR/locales/fi/TenantList.json";

      import WizardfiUrl from "ASSETS_DIR/locales/fi/Wizard.json";

      import ConfirmfrUrl from "ASSETS_DIR/locales/fr/Confirm.json";

      import ConsentfrUrl from "ASSETS_DIR/locales/fr/Consent.json";

      import ErrorsfrUrl from "ASSETS_DIR/locales/fr/Errors.json";

      import LoginfrUrl from "ASSETS_DIR/locales/fr/Login.json";

      import TenantListfrUrl from "ASSETS_DIR/locales/fr/TenantList.json";

      import WizardfrUrl from "ASSETS_DIR/locales/fr/Wizard.json";

      import ConfirmhyAMUrl from "ASSETS_DIR/locales/hy-AM/Confirm.json";

      import ConsenthyAMUrl from "ASSETS_DIR/locales/hy-AM/Consent.json";

      import ErrorshyAMUrl from "ASSETS_DIR/locales/hy-AM/Errors.json";

      import LoginhyAMUrl from "ASSETS_DIR/locales/hy-AM/Login.json";

      import TenantListhyAMUrl from "ASSETS_DIR/locales/hy-AM/TenantList.json";

      import WizardhyAMUrl from "ASSETS_DIR/locales/hy-AM/Wizard.json";

      import ConfirmitUrl from "ASSETS_DIR/locales/it/Confirm.json";

      import ConsentitUrl from "ASSETS_DIR/locales/it/Consent.json";

      import ErrorsitUrl from "ASSETS_DIR/locales/it/Errors.json";

      import LoginitUrl from "ASSETS_DIR/locales/it/Login.json";

      import TenantListitUrl from "ASSETS_DIR/locales/it/TenantList.json";

      import WizarditUrl from "ASSETS_DIR/locales/it/Wizard.json";

      import ConfirmjaJPUrl from "ASSETS_DIR/locales/ja-JP/Confirm.json";

      import ConsentjaJPUrl from "ASSETS_DIR/locales/ja-JP/Consent.json";

      import ErrorsjaJPUrl from "ASSETS_DIR/locales/ja-JP/Errors.json";

      import LoginjaJPUrl from "ASSETS_DIR/locales/ja-JP/Login.json";

      import TenantListjaJPUrl from "ASSETS_DIR/locales/ja-JP/TenantList.json";

      import WizardjaJPUrl from "ASSETS_DIR/locales/ja-JP/Wizard.json";

      import ConfirmkoKRUrl from "ASSETS_DIR/locales/ko-KR/Confirm.json";

      import ConsentkoKRUrl from "ASSETS_DIR/locales/ko-KR/Consent.json";

      import ErrorskoKRUrl from "ASSETS_DIR/locales/ko-KR/Errors.json";

      import LoginkoKRUrl from "ASSETS_DIR/locales/ko-KR/Login.json";

      import TenantListkoKRUrl from "ASSETS_DIR/locales/ko-KR/TenantList.json";

      import WizardkoKRUrl from "ASSETS_DIR/locales/ko-KR/Wizard.json";

      import ConfirmloLAUrl from "ASSETS_DIR/locales/lo-LA/Confirm.json";

      import ConsentloLAUrl from "ASSETS_DIR/locales/lo-LA/Consent.json";

      import ErrorsloLAUrl from "ASSETS_DIR/locales/lo-LA/Errors.json";

      import LoginloLAUrl from "ASSETS_DIR/locales/lo-LA/Login.json";

      import TenantListloLAUrl from "ASSETS_DIR/locales/lo-LA/TenantList.json";

      import WizardloLAUrl from "ASSETS_DIR/locales/lo-LA/Wizard.json";

      import ConfirmlvUrl from "ASSETS_DIR/locales/lv/Confirm.json";

      import ConsentlvUrl from "ASSETS_DIR/locales/lv/Consent.json";

      import ErrorslvUrl from "ASSETS_DIR/locales/lv/Errors.json";

      import LoginlvUrl from "ASSETS_DIR/locales/lv/Login.json";

      import TenantListlvUrl from "ASSETS_DIR/locales/lv/TenantList.json";

      import WizardlvUrl from "ASSETS_DIR/locales/lv/Wizard.json";

      import ConfirmnlUrl from "ASSETS_DIR/locales/nl/Confirm.json";

      import ConsentnlUrl from "ASSETS_DIR/locales/nl/Consent.json";

      import ErrorsnlUrl from "ASSETS_DIR/locales/nl/Errors.json";

      import LoginnlUrl from "ASSETS_DIR/locales/nl/Login.json";

      import TenantListnlUrl from "ASSETS_DIR/locales/nl/TenantList.json";

      import WizardnlUrl from "ASSETS_DIR/locales/nl/Wizard.json";

      import ConfirmplUrl from "ASSETS_DIR/locales/pl/Confirm.json";

      import ConsentplUrl from "ASSETS_DIR/locales/pl/Consent.json";

      import ErrorsplUrl from "ASSETS_DIR/locales/pl/Errors.json";

      import LoginplUrl from "ASSETS_DIR/locales/pl/Login.json";

      import TenantListplUrl from "ASSETS_DIR/locales/pl/TenantList.json";

      import WizardplUrl from "ASSETS_DIR/locales/pl/Wizard.json";

      import ConfirmptUrl from "ASSETS_DIR/locales/pt/Confirm.json";

      import ConsentptUrl from "ASSETS_DIR/locales/pt/Consent.json";

      import ErrorsptUrl from "ASSETS_DIR/locales/pt/Errors.json";

      import LoginptUrl from "ASSETS_DIR/locales/pt/Login.json";

      import TenantListptUrl from "ASSETS_DIR/locales/pt/TenantList.json";

      import WizardptUrl from "ASSETS_DIR/locales/pt/Wizard.json";

      import ConfirmptBRUrl from "ASSETS_DIR/locales/pt-BR/Confirm.json";

      import ConsentptBRUrl from "ASSETS_DIR/locales/pt-BR/Consent.json";

      import ErrorsptBRUrl from "ASSETS_DIR/locales/pt-BR/Errors.json";

      import LoginptBRUrl from "ASSETS_DIR/locales/pt-BR/Login.json";

      import TenantListptBRUrl from "ASSETS_DIR/locales/pt-BR/TenantList.json";

      import WizardptBRUrl from "ASSETS_DIR/locales/pt-BR/Wizard.json";

      import ConfirmroUrl from "ASSETS_DIR/locales/ro/Confirm.json";

      import ConsentroUrl from "ASSETS_DIR/locales/ro/Consent.json";

      import ErrorsroUrl from "ASSETS_DIR/locales/ro/Errors.json";

      import LoginroUrl from "ASSETS_DIR/locales/ro/Login.json";

      import TenantListroUrl from "ASSETS_DIR/locales/ro/TenantList.json";

      import WizardroUrl from "ASSETS_DIR/locales/ro/Wizard.json";

      import ConfirmruUrl from "ASSETS_DIR/locales/ru/Confirm.json";

      import ConsentruUrl from "ASSETS_DIR/locales/ru/Consent.json";

      import ErrorsruUrl from "ASSETS_DIR/locales/ru/Errors.json";

      import LoginruUrl from "ASSETS_DIR/locales/ru/Login.json";

      import TenantListruUrl from "ASSETS_DIR/locales/ru/TenantList.json";

      import WizardruUrl from "ASSETS_DIR/locales/ru/Wizard.json";

      import ConfirmsiUrl from "ASSETS_DIR/locales/si/Confirm.json";

      import ConsentsiUrl from "ASSETS_DIR/locales/si/Consent.json";

      import ErrorssiUrl from "ASSETS_DIR/locales/si/Errors.json";

      import LoginsiUrl from "ASSETS_DIR/locales/si/Login.json";

      import TenantListsiUrl from "ASSETS_DIR/locales/si/TenantList.json";

      import WizardsiUrl from "ASSETS_DIR/locales/si/Wizard.json";

      import ConfirmskUrl from "ASSETS_DIR/locales/sk/Confirm.json";

      import ConsentskUrl from "ASSETS_DIR/locales/sk/Consent.json";

      import ErrorsskUrl from "ASSETS_DIR/locales/sk/Errors.json";

      import LoginskUrl from "ASSETS_DIR/locales/sk/Login.json";

      import TenantListskUrl from "ASSETS_DIR/locales/sk/TenantList.json";

      import WizardskUrl from "ASSETS_DIR/locales/sk/Wizard.json";

      import ConfirmslUrl from "ASSETS_DIR/locales/sl/Confirm.json";

      import ConsentslUrl from "ASSETS_DIR/locales/sl/Consent.json";

      import ErrorsslUrl from "ASSETS_DIR/locales/sl/Errors.json";

      import LoginslUrl from "ASSETS_DIR/locales/sl/Login.json";

      import TenantListslUrl from "ASSETS_DIR/locales/sl/TenantList.json";

      import WizardslUrl from "ASSETS_DIR/locales/sl/Wizard.json";

      import ConfirmsqALUrl from "ASSETS_DIR/locales/sq-AL/Confirm.json";

      import ConsentsqALUrl from "ASSETS_DIR/locales/sq-AL/Consent.json";

      import ErrorssqALUrl from "ASSETS_DIR/locales/sq-AL/Errors.json";

      import LoginsqALUrl from "ASSETS_DIR/locales/sq-AL/Login.json";

      import TenantListsqALUrl from "ASSETS_DIR/locales/sq-AL/TenantList.json";

      import WizardsqALUrl from "ASSETS_DIR/locales/sq-AL/Wizard.json";

      import ConfirmsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Confirm.json";

      import ConsentsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Consent.json";

      import ErrorssrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Errors.json";

      import LoginsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Login.json";

      import TenantListsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/TenantList.json";

      import WizardsrCyrlRSUrl from "ASSETS_DIR/locales/sr-Cyrl-RS/Wizard.json";

      import ConfirmsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Confirm.json";

      import ConsentsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Consent.json";

      import ErrorssrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Errors.json";

      import LoginsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Login.json";

      import TenantListsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/TenantList.json";

      import WizardsrLatnRSUrl from "ASSETS_DIR/locales/sr-Latn-RS/Wizard.json";

      import ConfirmtrUrl from "ASSETS_DIR/locales/tr/Confirm.json";

      import ConsenttrUrl from "ASSETS_DIR/locales/tr/Consent.json";

      import ErrorstrUrl from "ASSETS_DIR/locales/tr/Errors.json";

      import LogintrUrl from "ASSETS_DIR/locales/tr/Login.json";

      import TenantListtrUrl from "ASSETS_DIR/locales/tr/TenantList.json";

      import WizardtrUrl from "ASSETS_DIR/locales/tr/Wizard.json";

      import ConfirmukUAUrl from "ASSETS_DIR/locales/uk-UA/Confirm.json";

      import ConsentukUAUrl from "ASSETS_DIR/locales/uk-UA/Consent.json";

      import ErrorsukUAUrl from "ASSETS_DIR/locales/uk-UA/Errors.json";

      import LoginukUAUrl from "ASSETS_DIR/locales/uk-UA/Login.json";

      import TenantListukUAUrl from "ASSETS_DIR/locales/uk-UA/TenantList.json";

      import WizardukUAUrl from "ASSETS_DIR/locales/uk-UA/Wizard.json";

      import ConfirmviUrl from "ASSETS_DIR/locales/vi/Confirm.json";

      import ConsentviUrl from "ASSETS_DIR/locales/vi/Consent.json";

      import ErrorsviUrl from "ASSETS_DIR/locales/vi/Errors.json";

      import LoginviUrl from "ASSETS_DIR/locales/vi/Login.json";

      import TenantListviUrl from "ASSETS_DIR/locales/vi/TenantList.json";

      import WizardviUrl from "ASSETS_DIR/locales/vi/Wizard.json";

      import ConfirmzhCNUrl from "ASSETS_DIR/locales/zh-CN/Confirm.json";

      import ConsentzhCNUrl from "ASSETS_DIR/locales/zh-CN/Consent.json";

      import ErrorszhCNUrl from "ASSETS_DIR/locales/zh-CN/Errors.json";

      import LoginzhCNUrl from "ASSETS_DIR/locales/zh-CN/Login.json";

      import TenantListzhCNUrl from "ASSETS_DIR/locales/zh-CN/TenantList.json";

      import WizardzhCNUrl from "ASSETS_DIR/locales/zh-CN/Wizard.json";

      import CommonarSAUrl from "PUBLIC_DIR/locales/ar-SA/Common.json";

      import CommonazUrl from "PUBLIC_DIR/locales/az/Common.json";

      import CommonbgUrl from "PUBLIC_DIR/locales/bg/Common.json";

      import CommoncsUrl from "PUBLIC_DIR/locales/cs/Common.json";

      import CommondeUrl from "PUBLIC_DIR/locales/de/Common.json";

      import CommonelGRUrl from "PUBLIC_DIR/locales/el-GR/Common.json";

      import CommonenUrl from "PUBLIC_DIR/locales/en/Common.json";

      import CommonesUrl from "PUBLIC_DIR/locales/es/Common.json";

      import CommonfiUrl from "PUBLIC_DIR/locales/fi/Common.json";

      import CommonfrUrl from "PUBLIC_DIR/locales/fr/Common.json";

      import CommonhyAMUrl from "PUBLIC_DIR/locales/hy-AM/Common.json";

      import CommonitUrl from "PUBLIC_DIR/locales/it/Common.json";

      import CommonjaJPUrl from "PUBLIC_DIR/locales/ja-JP/Common.json";

      import CommonkoKRUrl from "PUBLIC_DIR/locales/ko-KR/Common.json";

      import CommonloLAUrl from "PUBLIC_DIR/locales/lo-LA/Common.json";

      import CommonlvUrl from "PUBLIC_DIR/locales/lv/Common.json";

      import CommonnlUrl from "PUBLIC_DIR/locales/nl/Common.json";

      import CommonplUrl from "PUBLIC_DIR/locales/pl/Common.json";

      import CommonptUrl from "PUBLIC_DIR/locales/pt/Common.json";

      import CommonptBRUrl from "PUBLIC_DIR/locales/pt-BR/Common.json";

      import CommonroUrl from "PUBLIC_DIR/locales/ro/Common.json";

      import CommonruUrl from "PUBLIC_DIR/locales/ru/Common.json";

      import CommonsiUrl from "PUBLIC_DIR/locales/si/Common.json";

      import CommonskUrl from "PUBLIC_DIR/locales/sk/Common.json";

      import CommonslUrl from "PUBLIC_DIR/locales/sl/Common.json";

      import CommonsqALUrl from "PUBLIC_DIR/locales/sq-AL/Common.json";

      import CommonsrCyrlRSUrl from "PUBLIC_DIR/locales/sr-Cyrl-RS/Common.json";

      import CommonsrLatnRSUrl from "PUBLIC_DIR/locales/sr-Latn-RS/Common.json";

      import CommontrUrl from "PUBLIC_DIR/locales/tr/Common.json";

      import CommonukUAUrl from "PUBLIC_DIR/locales/uk-UA/Common.json";

      import CommonviUrl from "PUBLIC_DIR/locales/vi/Common.json";

      import CommonzhCNUrl from "PUBLIC_DIR/locales/zh-CN/Common.json";

 const arSA = new Map([
["Confirm", ConfirmarSAUrl],
["Consent", ConsentarSAUrl],
["Errors", ErrorsarSAUrl],
["Login", LoginarSAUrl],
["TenantList", TenantListarSAUrl],
["Wizard", WizardarSAUrl],
["Common", CommonarSAUrl]
]);
 const az = new Map([
["Confirm", ConfirmazUrl],
["Consent", ConsentazUrl],
["Errors", ErrorsazUrl],
["Login", LoginazUrl],
["TenantList", TenantListazUrl],
["Wizard", WizardazUrl],
["Common", CommonazUrl]
]);
 const bg = new Map([
["Confirm", ConfirmbgUrl],
["Consent", ConsentbgUrl],
["Errors", ErrorsbgUrl],
["Login", LoginbgUrl],
["TenantList", TenantListbgUrl],
["Wizard", WizardbgUrl],
["Common", CommonbgUrl]
]);
 const cs = new Map([
["Confirm", ConfirmcsUrl],
["Consent", ConsentcsUrl],
["Errors", ErrorscsUrl],
["Login", LogincsUrl],
["TenantList", TenantListcsUrl],
["Wizard", WizardcsUrl],
["Common", CommoncsUrl]
]);
 const de = new Map([
["Confirm", ConfirmdeUrl],
["Consent", ConsentdeUrl],
["Errors", ErrorsdeUrl],
["Login", LogindeUrl],
["TenantList", TenantListdeUrl],
["Wizard", WizarddeUrl],
["Common", CommondeUrl]
]);
 const elGR = new Map([
["Confirm", ConfirmelGRUrl],
["Consent", ConsentelGRUrl],
["Errors", ErrorselGRUrl],
["Login", LoginelGRUrl],
["TenantList", TenantListelGRUrl],
["Wizard", WizardelGRUrl],
["Common", CommonelGRUrl]
]);
 const en = new Map([
["Confirm", ConfirmenUrl],
["Consent", ConsentenUrl],
["Errors", ErrorsenUrl],
["Login", LoginenUrl],
["TenantList", TenantListenUrl],
["Wizard", WizardenUrl],
["Common", CommonenUrl]
]);
 const es = new Map([
["Confirm", ConfirmesUrl],
["Consent", ConsentesUrl],
["Errors", ErrorsesUrl],
["Login", LoginesUrl],
["TenantList", TenantListesUrl],
["Wizard", WizardesUrl],
["Common", CommonesUrl]
]);
 const fi = new Map([
["Confirm", ConfirmfiUrl],
["Consent", ConsentfiUrl],
["Errors", ErrorsfiUrl],
["Login", LoginfiUrl],
["TenantList", TenantListfiUrl],
["Wizard", WizardfiUrl],
["Common", CommonfiUrl]
]);
 const fr = new Map([
["Confirm", ConfirmfrUrl],
["Consent", ConsentfrUrl],
["Errors", ErrorsfrUrl],
["Login", LoginfrUrl],
["TenantList", TenantListfrUrl],
["Wizard", WizardfrUrl],
["Common", CommonfrUrl]
]);
 const hyAM = new Map([
["Confirm", ConfirmhyAMUrl],
["Consent", ConsenthyAMUrl],
["Errors", ErrorshyAMUrl],
["Login", LoginhyAMUrl],
["TenantList", TenantListhyAMUrl],
["Wizard", WizardhyAMUrl],
["Common", CommonhyAMUrl]
]);
 const it = new Map([
["Confirm", ConfirmitUrl],
["Consent", ConsentitUrl],
["Errors", ErrorsitUrl],
["Login", LoginitUrl],
["TenantList", TenantListitUrl],
["Wizard", WizarditUrl],
["Common", CommonitUrl]
]);
 const jaJP = new Map([
["Confirm", ConfirmjaJPUrl],
["Consent", ConsentjaJPUrl],
["Errors", ErrorsjaJPUrl],
["Login", LoginjaJPUrl],
["TenantList", TenantListjaJPUrl],
["Wizard", WizardjaJPUrl],
["Common", CommonjaJPUrl]
]);
 const koKR = new Map([
["Confirm", ConfirmkoKRUrl],
["Consent", ConsentkoKRUrl],
["Errors", ErrorskoKRUrl],
["Login", LoginkoKRUrl],
["TenantList", TenantListkoKRUrl],
["Wizard", WizardkoKRUrl],
["Common", CommonkoKRUrl]
]);
 const loLA = new Map([
["Confirm", ConfirmloLAUrl],
["Consent", ConsentloLAUrl],
["Errors", ErrorsloLAUrl],
["Login", LoginloLAUrl],
["TenantList", TenantListloLAUrl],
["Wizard", WizardloLAUrl],
["Common", CommonloLAUrl]
]);
 const lv = new Map([
["Confirm", ConfirmlvUrl],
["Consent", ConsentlvUrl],
["Errors", ErrorslvUrl],
["Login", LoginlvUrl],
["TenantList", TenantListlvUrl],
["Wizard", WizardlvUrl],
["Common", CommonlvUrl]
]);
 const nl = new Map([
["Confirm", ConfirmnlUrl],
["Consent", ConsentnlUrl],
["Errors", ErrorsnlUrl],
["Login", LoginnlUrl],
["TenantList", TenantListnlUrl],
["Wizard", WizardnlUrl],
["Common", CommonnlUrl]
]);
 const pl = new Map([
["Confirm", ConfirmplUrl],
["Consent", ConsentplUrl],
["Errors", ErrorsplUrl],
["Login", LoginplUrl],
["TenantList", TenantListplUrl],
["Wizard", WizardplUrl],
["Common", CommonplUrl]
]);
 const pt = new Map([
["Confirm", ConfirmptUrl],
["Consent", ConsentptUrl],
["Errors", ErrorsptUrl],
["Login", LoginptUrl],
["TenantList", TenantListptUrl],
["Wizard", WizardptUrl],
["Common", CommonptUrl]
]);
 const ptBR = new Map([
["Confirm", ConfirmptBRUrl],
["Consent", ConsentptBRUrl],
["Errors", ErrorsptBRUrl],
["Login", LoginptBRUrl],
["TenantList", TenantListptBRUrl],
["Wizard", WizardptBRUrl],
["Common", CommonptBRUrl]
]);
 const ro = new Map([
["Confirm", ConfirmroUrl],
["Consent", ConsentroUrl],
["Errors", ErrorsroUrl],
["Login", LoginroUrl],
["TenantList", TenantListroUrl],
["Wizard", WizardroUrl],
["Common", CommonroUrl]
]);
 const ru = new Map([
["Confirm", ConfirmruUrl],
["Consent", ConsentruUrl],
["Errors", ErrorsruUrl],
["Login", LoginruUrl],
["TenantList", TenantListruUrl],
["Wizard", WizardruUrl],
["Common", CommonruUrl]
]);
 const si = new Map([
["Confirm", ConfirmsiUrl],
["Consent", ConsentsiUrl],
["Errors", ErrorssiUrl],
["Login", LoginsiUrl],
["TenantList", TenantListsiUrl],
["Wizard", WizardsiUrl],
["Common", CommonsiUrl]
]);
 const sk = new Map([
["Confirm", ConfirmskUrl],
["Consent", ConsentskUrl],
["Errors", ErrorsskUrl],
["Login", LoginskUrl],
["TenantList", TenantListskUrl],
["Wizard", WizardskUrl],
["Common", CommonskUrl]
]);
 const sl = new Map([
["Confirm", ConfirmslUrl],
["Consent", ConsentslUrl],
["Errors", ErrorsslUrl],
["Login", LoginslUrl],
["TenantList", TenantListslUrl],
["Wizard", WizardslUrl],
["Common", CommonslUrl]
]);
 const sqAL = new Map([
["Confirm", ConfirmsqALUrl],
["Consent", ConsentsqALUrl],
["Errors", ErrorssqALUrl],
["Login", LoginsqALUrl],
["TenantList", TenantListsqALUrl],
["Wizard", WizardsqALUrl],
["Common", CommonsqALUrl]
]);
 const srCyrlRS = new Map([
["Confirm", ConfirmsrCyrlRSUrl],
["Consent", ConsentsrCyrlRSUrl],
["Errors", ErrorssrCyrlRSUrl],
["Login", LoginsrCyrlRSUrl],
["TenantList", TenantListsrCyrlRSUrl],
["Wizard", WizardsrCyrlRSUrl],
["Common", CommonsrCyrlRSUrl]
]);
 const srLatnRS = new Map([
["Confirm", ConfirmsrLatnRSUrl],
["Consent", ConsentsrLatnRSUrl],
["Errors", ErrorssrLatnRSUrl],
["Login", LoginsrLatnRSUrl],
["TenantList", TenantListsrLatnRSUrl],
["Wizard", WizardsrLatnRSUrl],
["Common", CommonsrLatnRSUrl]
]);
 const tr = new Map([
["Confirm", ConfirmtrUrl],
["Consent", ConsenttrUrl],
["Errors", ErrorstrUrl],
["Login", LogintrUrl],
["TenantList", TenantListtrUrl],
["Wizard", WizardtrUrl],
["Common", CommontrUrl]
]);
 const ukUA = new Map([
["Confirm", ConfirmukUAUrl],
["Consent", ConsentukUAUrl],
["Errors", ErrorsukUAUrl],
["Login", LoginukUAUrl],
["TenantList", TenantListukUAUrl],
["Wizard", WizardukUAUrl],
["Common", CommonukUAUrl]
]);
 const vi = new Map([
["Confirm", ConfirmviUrl],
["Consent", ConsentviUrl],
["Errors", ErrorsviUrl],
["Login", LoginviUrl],
["TenantList", TenantListviUrl],
["Wizard", WizardviUrl],
["Common", CommonviUrl]
]);
 const zhCN = new Map([
["Confirm", ConfirmzhCNUrl],
["Consent", ConsentzhCNUrl],
["Errors", ErrorszhCNUrl],
["Login", LoginzhCNUrl],
["TenantList", TenantListzhCNUrl],
["Wizard", WizardzhCNUrl],
["Common", CommonzhCNUrl]
]);
 export const translations = new Map([
["ar-SA", arSA],
["az", az],
["bg", bg],
["cs", cs],
["de", de],
["el-GR", elGR],
["en", en],
["es", es],
["fi", fi],
["fr", fr],
["hy-AM", hyAM],
["it", it],
["ja-JP", jaJP],
["ko-KR", koKR],
["lo-LA", loLA],
["lv", lv],
["nl", nl],
["pl", pl],
["pt", pt],
["pt-BR", ptBR],
["ro", ro],
["ru", ru],
["si", si],
["sk", sk],
["sl", sl],
["sq-AL", sqAL],
["sr-Cyrl-RS", srCyrlRS],
["sr-Latn-RS", srLatnRS],
["tr", tr],
["uk-UA", ukUA],
["vi", vi],
["zh-CN", zhCN],
]);